// FCM bildiriş göndərmək üçün köməkçi funksiyalar.
// Backend: https://appmobile.svurguns.cyou/Data/api/app123/test/Notification.php
//
// Backend `send` action-ı token boş olduqda receiver_id-yə görə son qoşulan
// cihazın token-ini DB-dən özü tapır — beləcə burada yalnız user_id ötürmək kifayətdir.

export const NOTIFY_API_URL =
  "https://appmobile.svurguns.cyou/Data/api/app123/test/Notification.php";

const post = (payload) =>
  fetch(NOTIFY_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

/**
 * Konkret istifadəçiyə bildiriş göndərir.
 * Uğursuzluq səssiz qaytarılır (UI axınını dayandırmamaq üçün) — yalnız konsola yazılır.
 */
export const notifyUser = async ({
  userId,
  title,
  body,
  data = {},
  senderId,
} = {}) => {
  if (!userId || !title || !body) {
    console.warn("notifyUser: userId/title/body məcburidir");
    return { ok: false, error: "missing params" };
  }
  try {
    const res = await post({
      action: "send",
      receiver_id: userId,
      sender_id: senderId ?? null,
      title,
      body,
      data: { ...data, user_id: String(userId) },
    });
    const text = await res.text();
    let json;
    try {
      json = JSON.parse(text);
    } catch {
      json = { raw: text };
    }
    return { ok: res.ok && json.success !== false, json };
  } catch (err) {
    console.warn("notifyUser xətası:", err);
    return { ok: false, error: err.message };
  }
};

/**
 * Kart yenilənəndə standart bildiriş.
 */
export const notifyCardUpdated = (userId, extra = {}) =>
  notifyUser({
    userId,
    title: "Kartınız yeniləndi",
    body: `Vəsiqə #${userId} məlumatları yeniləndi.`,
    data: { type: "card_updated", ...extra },
    senderId: localStorage.getItem("username") || null,
  });
